module.exports = __webpack_public_path__ + "img/layout_horizontal_s.bd296bcd.svg";